"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var error_reason_1 = require("./../../errors/error-reason");
var topic_specification_1 = require("./../../topics/topic-specification");
var topic_type_1 = require("./../../topics/topic-type");
var topics_1 = require("./../../topics/topics");
var close_reason_1 = require("./../client/close-reason");
var abstract_datatype_1 = require("./../data/abstract-datatype");
var datatypes_1 = require("./../data/datatypes");
var time_series_event_datatype_1 = require("./../timeseries/time-series-event-datatype");
var topic_selector_parser_1 = require("./../topics/topic-selector-parser");
/**
 * The context sharing core datatypes and enums with the features. In the
 * modular client, this constant is packaged with the core diffusion
 * package.
 */
exports.sessionContext = {
    ErrorReason: error_reason_1.ErrorReason,
    TopicTypeEnum: topic_type_1.TopicTypeEnum,
    TopicAddFailReasonEnum: topics_1.TopicAddFailReasonEnum,
    TopicSpecification: topic_specification_1.TopicSpecification,
    TimeSeriesEventDataType: time_series_event_datatype_1.TimeSeriesEventDataType,
    DataTypes: datatypes_1.DataTypes,
    AbstractDataType: abstract_datatype_1.AbstractDataType,
    parseSelector: topic_selector_parser_1.parseSelector,
    CloseReason: close_reason_1.CloseReasonImpl
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/client/session-context-impl.js
// module id = 495
// module chunks = 1